/**
 * 当前登录学生的范围筛选 mixin。
 *
 * 级别和科目由服务端根据登录 token 中的 campus_id 返回，前端不加载
 * 或切换其他学校的数据。
 */
export default {
  data() {
    return {
      scopeGradeList: [],
      scopeSubjectList: []
    }
  },
  computed: {
    // 保留 background 页面可能引用的权限字段，但 student 不显示学校范围控件。
    isSuper() {
      return false
    },
    isAdmin() {
      return false
    }
  },
  methods: {
    // 在页面 mounted 中调用一次。
    scopeSearchInit() {
      return this.loadScopeOptions()
    },

    // targetSearchData 用于页面中同时存在多个筛选表单的场景。
    loadScopeOptions(targetSearchData = this.searchData) {
      return this.$axios.get('/app/auth/getScopeGradeSubject').then(res => {
        if (!res || res.code !== 1) return

        const data = res.data || {}
        this.scopeGradeList = (data.grades || []).map(item => ({
          ...item,
          id: Number(item.id)
        }))
        this.scopeSubjectList = (data.subjects || []).map(item => ({
          ...item,
          id: Number(item.id)
        }))

        // 学校配置变化后，清除不再可选的已选条件。
        const filter = targetSearchData && typeof targetSearchData === 'object'
          ? targetSearchData
          : null
        const usesScopeKeys = !!(filter && ('scope_grade_id' in filter || 'scope_subject_id' in filter))
        const gradeKey = usesScopeKeys ? 'scope_grade_id' : 'grade_id'
        const subjectKey = usesScopeKeys ? 'scope_subject_id' : 'subject_id'
        const gradeId = Number(filter && filter[gradeKey])
        const subjectId = Number(filter && filter[subjectKey])
        if (gradeId > 0 && !this.scopeGradeList.some(item => item.id === gradeId)) {
          this.$set(filter, gradeKey, '')
        }
        if (subjectId > 0 && !this.scopeSubjectList.some(item => item.id === subjectId)) {
          this.$set(filter, subjectKey, '')
        }
      }).catch(() => {})
    }
  }
}
